import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import Auctioneer from './components/Auctioneer';
import LandingPage from './components/landing/LandingPage';
import MobileBlockModal from './components/MobileBlockModal';
import isMobileDevice from './utils/isMobileDevice';
import './App.css';

/** Blocks mobile/tablet users from loading the auction directly via URL. */
function AuctionGate() {
  const navigate = useNavigate();

  if (isMobileDevice()) {
    return (
      <MobileBlockModal
        isOpen={true}
        onDismiss={() => navigate('/')}
      />
    );
  }

  return <Auctioneer />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auction" element={<AuctionGate />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
